// @ts-check

if (!customElements.get("ff-navigation-tab")) {
  class FfNavigationTab extends HTMLElement {
    constructor() {
      super();

      const { ffContentSelector } = this.dataset;

      if (ffContentSelector) {
        this.ffContentSelector = ffContentSelector;
      } else {
        const errorMsg = [];

        if (!ffContentSelector) {
          errorMsg.push(`ffContentSelector equal to "${ffContentSelector}"`);
        }

        throw new Error(errorMsg.join("\n"));
      }
    }

    /**
     * The scope to hide or show contents is limited to FfNavigationTabs
     * @param {FfNavigationTabs} navigationTabs
     */
    ffInit(navigationTabs) {
      const { ffInitialActive } = this.dataset;

      /**
       * @type {NodeListOf<HTMLElement>}
       */
      this.ffContents = navigationTabs.querySelectorAll(this.ffContentSelector);

      if (this.ffContents.length == 0)
        throw new Error(
          `No contents for ${this.ffContentSelector} were found.`
        );

      if (ffInitialActive) {
        this.ffShowContents();
      } else {
        this.ffHideContents();
      }
    }

    ffHideContents() {
      if (this.dataset.ffActiveClass) {
        this.classList.remove(this.dataset.ffActiveClass);
      }

      this.ffContents?.forEach((content) => {
        if (this.dataset.ffShowClass) {
          content.classList.remove(this.dataset.ffShowClass);
        }

        if (this.dataset.ffHideClass) {
          content.classList.add(this.dataset.ffHideClass);
        }

        if (!this.dataset.ffHideClass && !this.dataset.ffShowClass) {
          content.style.display = "none";
        }
      });
    }

    ffShowContents() {
      if (this.dataset.ffActiveClass) {
        this.classList.add(this.dataset.ffActiveClass);
      }

      this.ffContents?.forEach((content) => {
        if (this.dataset.ffHideClass) {
          content.classList.remove(this.dataset.ffHideClass);
        }

        if (this.dataset.ffShowClass) {
          content.classList.add(this.dataset.ffShowClass);
        }

        if (!this.dataset.ffShowClass && !this.dataset.ffHideClass) {
          content.style.display = "";
        }
      });
    }
  }

  customElements.define("ff-navigation-tab", FfNavigationTab);
}

if (!customElements.get("ff-navigation-tabs")) {
  class FfNavigationTabs extends HTMLElement {
    constructor() {
      super();

      this.ffInit();
    }

    ffInit() {
      if (!this.dataset.hasOwnProperty("ffDisabled")) {
        if (this.dataset.ffDefaultContentSelector) {
          /**
           * @type {NodeListOf<HTMLElement>}
           */
          this.ffDefaultContents = this.querySelectorAll(
            this.dataset.ffDefaultContentSelector
          );
        }

        /**
         * @type {NodeListOf<FfNavigationTab>}
         */
        const tabsEl = this.querySelectorAll(`[data-ff-tab='${this.id}']`);

        if (tabsEl.length == 0)
          throw new Error("No tabs for this navigation tabs were found.");

        let foundActiveTab = false; //Limits only one tab to be active on initialization

        tabsEl.forEach((tabEl) => {
          if (tabEl.dataset.ffInitialActive) {
            if (foundActiveTab == true) {
              tabEl.dataset.ffInitialActive = "";
            }
            foundActiveTab = true;
          }

          tabEl.ffInit(this);

          tabEl.addEventListener("click", () => {
            tabsEl.forEach((tabEl) => tabEl.ffHideContents());
            this.ffHideDefaultContents();
            tabEl.ffShowContents();
          });
        });

        if (foundActiveTab) {
          this.ffHideDefaultContents();
        }
      }
    }

    ffHideDefaultContents() {
      this.ffDefaultContents?.forEach((content) => {
        content.remove();
      });
    }
  }

  customElements.define("ff-navigation-tabs", FfNavigationTabs);
}

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    requestAnimationFrame(() => {
      document.querySelectorAll("ff-navigation-tabs").forEach((tabs) => {
        tabs.ffInit();
      });
    });
  });
}
